export const LOAD_USERS = '[user] load users';
export const LOAD_ARCHIVE_USERS = '[user] load archive users';
export const ADD_USER = '[user] add user';
export const GET_USER = '[user] get user';
export const EDIT_USER = '[users] edit user';
export const REMOVE_USER = '[user] remove user';
export const ARCHIVE_USER = '[user] archive user';
export const UNARCHIVE_USER = '[user] unarchive user';
export const PROCESS_USER = '[user] process user';
export const PROCESS_EDIT_USER = '[user] process editing a user';
export const PROCESS_ARCHIVE_USER = '[user] process archiving user';
export const PROCESS_UNARCHIVE_USER = '[user] process unarchiving user';
export const PROCESS_NEW_USER = '[user] process new user';
export const PROCESS_NEW_STAFF_USER = '[user] process new staff user';
export const PROCESS_STAFF_USER = '[user] process staff user';

export const PROCESS_USERS = '[user] process users';
export const INSERT_USER = '[user] insert user';
export const USER_ERROR = '[user] user error';
export const USER_LOAD_ERROR = '[user] user load error';
export const USER_STATUS_ERROR = '[user] user status load error';
export const USER_ADD_ERROR = '[user] user add error';

export const USER_EDIT_ERROR = '[user] user edit error';
export const USER_ARCHIVE_ERROR = '[user] user archive error';
export const LOAD_PROCESSED_USERS = '[user] load processed users';
export const LOAD_USER_STATUSES = '[user] load user statuses';
export const PROCESS_USER_STATUSES = '[user] process user statuses';
export const INSERT_USER_STATUSES = '[user] insert user statuses';
export const LOAD_CHECKIN_MODES = '[user] load checkin modes';
export const PROCESS_CHECKIN_MODES = '[user] process checkin modes';
export const INSERT_CHECKIN_MODES = '[user] insert checkin modes';
export const CHECKIN_MODES_ERROR = '[user] checkin modes error';
export const EDIT_USER_STATUS = '[user] edit user status';
export const EDIT_USER_PASSWORD = '[user] edit user password';
export const EDIT_USER_NOTES = '[user] edit user notes';
export const EDIT_USER_IMAGE = '[user] edit user image';
export const REMOVE_USER_IMAGE = '[user] remove user image';

export const LOAD_PANIC_BUTTONS = '[user] load panic buttons';
export const PROCESS_PANIC_BUTTONS = '[user] process panic buttons';
export const INSERT_PANIC_BUTTONS = '[user] insert panic buttons';
export const PANIC_BUTTONS_ERROR = '[user] panic buttons error';
export const LOAD_ASSOCIATED_USER_PANIC_BUTTONS =
  '[user] load associated user panic buttons';
export const PROCESS_ASSOCIATED_USER_PANIC_BUTTONS =
  '[user] process associated user panic buttons';
export const ASSOCIATE_USER_PANIC_BUTTONS =
  '[user] associate user panic buttons';
export const PROCESS_ASSOCIATED_USER_PANIC_BUTTON =
  '[user] process associated user panic button';
export const INSERT_ASSOCIATED_USER_PANIC_BUTTON =
  '[user] insert associated user panic button';
export const ASSOCIATE_USER_PANIC_BUTTONS_ERROR =
  '[user] associate user panic buttons error';
export const REMOVE_ASSOCIATED_USER_PANIC_BUTTON =
  '[user] remove associated user panic button';
export const PROCESS_REMOVING_ASSOCIATED_USER_PANIC_BUTTON =
  '[user] process removing associated user panic button';
export const DELETE_ASSOCIATED_USER_PANIC_BUTTON =
  '[user] delete associated user panic button';
export const EXPORT_USERS = '[user] export users csv';
export const PROCESS_EXPORT_USERS = '[user] process export users csv';
export const IMPORT_USERS = '[user] import users csv';
export const CONFIRM_IMPORT_USERS = '[user] confirm import users csv';
export const USERS_IMPORT_ERROR = '[user] import users csv error';
export const SET_LAST_USERS_CHECKED = '[user] Set last time users was checked';
export const CREATE_MASSNOTIFICATION_DEVICE = 'CREATE_MASSNOTIFICATION_DEVICE';
export const PROCESS_MASSNOTIFICATION_DEVICE = 'PROCESS_MASSNOTIFICATION_DEVICE';  
export const MASSNOTIFICATION_DEVICE_ERROR = 'MASSNOTIFICATION_DEVICE_ERROR';

export const addUser = (user, navigate, previous) => ({
  type: ADD_USER,
  payload: user,
  navigate: navigate,
  previous,
});

export const editUser = (user, navigate, previous) => ({
  type: EDIT_USER,
  payload: user,
  navigate: navigate,
  previous,
});
export const getUser = (user, navigate, previous) => ({
  type: GET_USER,
  payload: user,
  navigate: navigate,
  previous,
});
export const editUserStatus = (user) => ({
  type: EDIT_USER_STATUS,
  payload: user,
});
export const editUserPassword = (user, navigate, previous) => ({
  type: EDIT_USER_PASSWORD,
  payload: user,
  navigate: navigate,
  previous,
});
export const editUserNotes = (user) => ({
  type: EDIT_USER_NOTES,
  payload: user,
});

export const archiveUser = (userId, navigate) => ({
  type: ARCHIVE_USER,
  payload: userId,
  navigate: navigate,
});

export const unArchiveUser = (userId, navigate) => ({
  type: UNARCHIVE_USER,
  payload: userId,
  navigate: navigate,
});
export const editUserImage = (body, meta) => ({
  type: EDIT_USER_IMAGE,
  payload: body,
  meta,
});
export const removeUserImage = (body, meta) => ({
  type: REMOVE_USER_IMAGE,
  payload: body,
  meta,
});

export const processArchiveUser = () => ({
  type: PROCESS_ARCHIVE_USER,
});

export const processUnArchiveUser = () => ({
  type: PROCESS_UNARCHIVE_USER,
});

export const removeUser = (user) => ({
  type: REMOVE_USER,
  payload: user,
});

export const processUser = (user) => ({
  type: PROCESS_USER,
  payload: user,
});

export const processEditUser = () => ({
  type: PROCESS_EDIT_USER,
});
export const processStaffUser = () => ({
  type: PROCESS_STAFF_USER,
});

export const processNewUser = () => ({
  type: PROCESS_NEW_USER,
});
export const processNewStaffUser = () => ({
  type: PROCESS_NEW_STAFF_USER,
});

export const processUsers = () => ({
  type: PROCESS_USERS,
});

export const loadUsers = (users) => ({
  type: LOAD_USERS,
  payload: users,
});

export const loadArchiveUsers = () => ({
  type: LOAD_ARCHIVE_USERS,
});

export const insertUser = (user) => ({
  type: INSERT_USER,
  payload: user,
});

export const userError = () => ({
  type: USER_ERROR,
});

export const userLoadError = () => ({
  type: USER_LOAD_ERROR,
});
export const userStatusLoadError = () => ({
  type: USER_STATUS_ERROR,
});

export const userAddError = (error) => ({
  type: USER_ADD_ERROR,
  payload: error,
});

export const userArchiveError = (error) => ({
  type: USER_ARCHIVE_ERROR,
  payload: error,
});
export const userEditError = (error) => ({
  type: USER_EDIT_ERROR,
  payload: error,
});

export const loadProcessedUsers = (processedUsers, currentTime) => ({
  type: LOAD_PROCESSED_USERS,
  payload: processedUsers,
  currentTime,
});

export const loadUserStatuses = () => ({
  type: LOAD_USER_STATUSES,
});

export const processUserStatuses = (statuses) => ({
  type: PROCESS_USER_STATUSES,
  payload: statuses,
});
export const insertUserStatuses = (statuses) => ({
  type: INSERT_USER_STATUSES,
  payload: statuses,
});

export const loadCheckinModes = () => ({
  type: LOAD_CHECKIN_MODES,
});

export const processCheckinModes = (modes) => ({
  type: PROCESS_CHECKIN_MODES,
  payload: modes,
});
export const insertCheckinModes = (modes) => ({
  type: INSERT_CHECKIN_MODES,
  payload: modes,
});
export const checkinModesError = (modes) => ({
  type: CHECKIN_MODES_ERROR,
  payload: modes,
});

export const loadPanicButtons = () => ({
  type: LOAD_PANIC_BUTTONS,
});

export const processPanicButtons = (buttons) => ({
  type: PROCESS_PANIC_BUTTONS,
  payload: buttons,
});
export const insertPanicButtons = (buttons) => ({
  type: INSERT_PANIC_BUTTONS,
  payload: buttons,
});
export const panicButtonsError = (buttons) => ({
  type: PANIC_BUTTONS_ERROR,
  payload: buttons,
});

export const loadAssociatedUserPanicButtons = (button) => ({
  type: LOAD_ASSOCIATED_USER_PANIC_BUTTONS,
  payload: button,
});

export const processAssociatedUserPanicButtons = (button) => ({
  type: PROCESS_ASSOCIATED_USER_PANIC_BUTTONS,
  payload: button,
});

export const associateUserPanicButtons = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: ASSOCIATE_USER_PANIC_BUTTONS,
  payload,
  navigate: navigate,
  previous,
  formSteps,
});

export const processAssociatedUserPanicButton = (button) => ({
  type: PROCESS_ASSOCIATED_USER_PANIC_BUTTON,
  payload: button,
});
export const insertAssociatedUserPanicButton = (button) => ({
  type: INSERT_ASSOCIATED_USER_PANIC_BUTTON,
  payload: button,
});
export const removeAssociatedUserPanicButton = (
  payload,
  navigate,
  previous,
  formSteps
) => ({
  type: REMOVE_ASSOCIATED_USER_PANIC_BUTTON,
  payload,
  navigate: navigate,
  previous,
  formSteps,
});
export const processRemvoingAssociatedUserPanicButton = (button) => ({
  type: PROCESS_REMOVING_ASSOCIATED_USER_PANIC_BUTTON,
  payload: button,
});
export const deleteAssociatedUserPanicButton = (button) => ({
  type: DELETE_ASSOCIATED_USER_PANIC_BUTTON,
  payload: button,
});
export const associateUserPanicButtonsError = (button) => ({
  type: ASSOCIATE_USER_PANIC_BUTTONS_ERROR,
  payload: button,
});

export const exportUsers = (payload, navigate, previous) => ({
  type: EXPORT_USERS,
  payload,
  navigate: navigate,
  previous,
});
export const processExportUsers = (data, navigate, previous) => ({
  type: PROCESS_EXPORT_USERS,
  payload: data,
  navigate: navigate,
  previous,
});
export const importUsers = (data, navigate, previous) => ({
  type: IMPORT_USERS,
  payload: data,
  navigate: navigate,
  previous,
});

export const confirmImportUsers = (data, navigate, previous) => ({
  type: CONFIRM_IMPORT_USERS,
  payload: data,
  navigate: navigate,
  previous,
});
export const usersImportError = (error) => ({
  type: USERS_IMPORT_ERROR,
  payload: error,
});
export const setLastUsersChecked = (payload) => ({
  type: SET_LAST_USERS_CHECKED,
  payload,
});
export const createMassnotificationDevice = (value, navigate, formSteps, previous) => ({
  type: CREATE_MASSNOTIFICATION_DEVICE,
  payload: value,
  navigate,
  formSteps,
  previous,
});
